import { useState, useEffect } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import BACKEND_URL from '../config';
import { useUser } from '../../hooks/useUser';
import { useLogout } from '../../hooks/authentication_helper';

export const NAVBAR_SLOT_ID = 'navbar-center-slot';

const VnogNavbar = () => {
    const [isAdminUser, setIsAdminUser] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    const userApi = useUser();
    const logout = useLogout();
    const isLoggedIn = userApi.state === 'LoggedIn';

    useEffect(() => {
        if (!isLoggedIn) return;
        fetch(`${BACKEND_URL}/vnog/is_admin_user/`, {
            method: 'GET',
            credentials: 'include',
        })
        .then(response => response.json())
        .then(data => setIsAdminUser(data.is_admin_user === true))
        .catch(() => setIsAdminUser(false));
    }, [isLoggedIn]);

    const getSimulationLink = () => {
        if (location.pathname === '/home') return '/home' + location.search;
        const lastToken = localStorage.getItem('vnog_last_simulation');
        return lastToken ? `/home?simulation=${lastToken}` : '/home';
    };

    const navLinkClass = ({ isActive }: { isActive: boolean }) =>
        `px-4 py-2 text-sm font-medium rounded-lg transition-all duration-150 ${
            isActive
                ? 'text-blue-700 bg-blue-50'
                : 'text-gray-500 hover:text-gray-900 hover:bg-gray-100'
        }`;

    return (
        <nav className="sticky top-0 z-40 bg-white/80 backdrop-blur-md border-b border-gray-200/60">
            <div className="flex items-center justify-between h-32 px-8">
                <NavLink to="/home" className="flex items-center gap-4 shrink-0 flex-col">
                    <img src="/vnog.svg" alt="VNOG" className="h-12 w-auto" />
                    <p className="text-xs text-gray-400 hidden sm:block">
                        Virtuele Assistent Bevelvoerder
                    </p>
                </NavLink>

                <div id={NAVBAR_SLOT_ID} className="flex-1 flex items-center justify-center px-4" />

                <div className="flex items-center gap-2 shrink-0">
                    {isLoggedIn && (
                        <>
                            <NavLink to={getSimulationLink()} className={navLinkClass}>
                                Simulatie
                            </NavLink>
                            <NavLink to="/document_interpretation" className={navLinkClass}>
                                Document Centrum
                            </NavLink>
                            {isAdminUser && (
                                <NavLink to="/admin_vnog" className={navLinkClass}>
                                    Beheer
                                </NavLink>
                            )}
                            <div className="w-px h-5 bg-gray-200 mx-1" />
                            <button
                                onClick={logout}
                                className="px-4 py-2 text-sm font-medium rounded-lg text-gray-500 hover:text-red-600 hover:bg-red-50 transition-all duration-150"
                            >
                                Uitloggen
                            </button>
                        </>
                    )}
                    {!isLoggedIn && (
                        <button
                            onClick={() => navigate('/')}
                            className="px-4 py-2 text-sm font-medium rounded-lg text-white bg-blue-600 hover:bg-blue-700 transition-all duration-150"
                        >
                            Inloggen
                        </button>
                    )}
                </div>
            </div>
        </nav>
    );
};

export default VnogNavbar;
